export namespace TaskTranslations {
  export const common = {
    uncountSuccessful: 'uncountSuccessful',
  } as const;
}
